import useLazyData from '@/hooks/useLazyData';
import Skeleton from './skeleton';
import Container from '../Layout/container';
import BannerList from './banner-list';

const BannerArraySkeleton = ({ cmsComponentKey }) => (
  <Container cmsComponentKey={cmsComponentKey} className="pr-2.5 overflow-hidden">
    <Skeleton />
  </Container>
);

const BannerArray = props => {
  const { useSkeleton = true } = props;
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <BannerArraySkeleton cmsComponentKey={props.cmsComponentKey} />;

  if (!useSkeleton) {
    return <BannerList skeleton={skeleton} {...props} />;
  }

  return <div ref={viewRef}>{show ? <BannerList skeleton={skeleton} {...props} /> : skeleton}</div>;
};

export default BannerArray;
